import {createReducerNormalized} from 'util/redux/createReducerNormalized'
import {CFGroupTO} from 'generated/JavaTO'
import {resetCFDefGroupsAction} from 'module/CFGroup/action/CFGroupAction'
import {combineReducers} from 'redux'

const {byId, allIds} = createReducerNormalized<CFGroupTO, number>({
	idProp: 'id',
	resetAction: resetCFDefGroupsAction,
})
export const CFGroupReducerNS = {CFGroup: combineReducers({byId, allIds})}
export type CFGroupStateType = { CFGroup: ReturnType<typeof CFGroupReducerNS.CFGroup> }